export type CustomerIdentificationInputField = Readonly<{
    xmlId: string;
    label: string;
    value: string;
    // the order in which the customer identification input fields are being rendererd in the client
    order: number;
}>;

export const initialCustomerIdentificationInputFieldState: CustomerIdentificationInputField = {
    xmlId: '',
    label: '',
    value: '',
    order: -1,
};

export type SortedCustomerIdentificationInputField = CustomerIdentificationInputField & {
    key: string;
};
